import React from "react";

export default function LoadingScreen({ text = "Loading..." }: { text?: string }) {
    return (
        <div className="flex min-h-[60vh] w-full items-center justify-center widertalk-cream">
            <div className="flex flex-col items-center">
                <span className="animate-spin rounded-full border-4 border-purple-300 border-t-transparent h-12 w-12 mb-4"></span>
                <span className="text-lg font-semibold text-purple-700">{text}</span>
            </div>
        </div>
    );
}